import React from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Grid,
} from "@mui/material";

const NocMemoChallanPopup = ({ nocPaymentDetails }) => {
  if (!nocPaymentDetails) return <Typography>No data available</Typography>;

  // Calculate total amount
  const totalAmount = nocPaymentDetails?.additionalHeads?.reduce(
    (acc, head) => acc + Number(head.amount || 0),
    0
  );

  return (
    <Box p={4}>
      {/* Header */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        mb={2}
        border={1}
        borderColor="grey.800"
        p={2}
      >
        <Box textAlign="center">
          <Typography variant="h6">Memo Challan</Typography>
          <Typography variant="subtitle1">Demand Note (NOC)</Typography>
        </Box>
      </Box>

      {/* Info Section */}
      <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
        <Grid container spacing={1}>
          {nocPaymentDetails?.challanNo && (
            <Grid item xs={12} sm={6}>
              <strong>Challan No.:</strong> {nocPaymentDetails.challanNo}
            </Grid>
          )}
          {nocPaymentDetails?.holderName && (
            <Grid item xs={12} sm={6}>
              <strong>Holder Name:</strong> {nocPaymentDetails.holderName}
            </Grid>
          )}
          {nocPaymentDetails?.bankName && (
            <Grid item xs={12} sm={6}>
              <strong>Bank Name:</strong> {nocPaymentDetails.bankName}
            </Grid>
          )}
          {nocPaymentDetails?.ifscCode && (
            <Grid item xs={12} sm={6}>
              <strong>IFSC Code:</strong> {nocPaymentDetails.ifscCode}
            </Grid>
          )}
        </Grid>
      </Paper>

      {/* Table */}
      <Table component={Paper} size="small">
        <TableHead>
          <TableRow>
            <TableCell>Sr. No.</TableCell>
            <TableCell>Fee Type</TableCell>
            <TableCell>Plot Area</TableCell>
            <TableCell>Unit</TableCell>
            <TableCell>Rate</TableCell>
            <TableCell>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {nocPaymentDetails?.additionalHeads?.length > 0 ? (
            nocPaymentDetails.additionalHeads.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.feeType || "-"}</TableCell>
                <TableCell>{row.plotBuildUpArea || "-"}</TableCell>
                <TableCell>{row.unit || "-"}</TableCell>
                <TableCell>{row.rate || "-"}</TableCell>
                <TableCell>{row.amount || "-"}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center">
                No payment details available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      {/* Footer */}
      <Box mt={2} display="flex" justifyContent="space-between">
        <Typography variant="body2">
          <p>
            <strong>Total Amount (In INR):</strong> ₹ {totalAmount || "NA"}
          </p>
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="body2">
          <strong>Note:</strong> Amount calculated is based on NOC challan formula.
        </Typography>
      </Box>
    </Box>
  );
};

export default NocMemoChallanPopup;
